import { render } from "./ResForm.vue?vue&type=template&id=26079966"
import script from "./ResForm.vue?vue&type=script&lang=js"
export * from "./ResForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__